import React from 'react';
import styled from 'styled-components';
import { space, layout, flexbox } from 'styled-system';
import { Plus } from '../plus/Plus';

export const List = styled.div`
  ${space}
  ${layout}
  ${flexbox}
  display: flex;
`;

/**
 * @typedef GroupProp
 * @property {React.ReactNode} children
 * @property {number} maxCounts
 * @property {any} itemStyle
 */
/**
 * @param {GroupProp}
 */
export const Group = ({ children, maxCounts, itemStyle, ...rest }) => {
  const arr = React.Children.toArray(children);
  const hiddenCounts = arr.length - maxCounts;

  return (
    <List {...rest}>
      {arr.slice(0, maxCounts).map(child => React.cloneElement(child, itemStyle))}
      {hiddenCounts > 0 && <Plus number={hiddenCounts} />}
    </List>
  );
};

Group.defaultProps = {
  maxCounts: Infinity,
  itemStyle: { mr: '4px' },
  width: '100%',
};
